import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';

export const PRINT_REPORT = '@REPORT/CREATE_PATIENT_GROUP';
export const PRINT_REPORT_SUCCESS = '@REPORT/PRINT_REPORT_SUCCESS';
export const PRINT_REPORT_FAIL = '@REPORT/PRINT_REPORT_FAIL';
export const CLEAR_HISTORY_FILE = '@REPORT/CLEAR_HISTORY_FILE';

export function printReport(doctorId) {
  return (dispatch) => {
    dispatch({ type: PRINT_REPORT });
    HttpService.get(`api/doctors/${doctorId}/export-patients`)
      .then((resp) => {
        if (resp.data) {
          dispatch({ type: PRINT_REPORT_SUCCESS, payload: { data: resp.data } });
        } else {
          dispatch({ type: PRINT_REPORT_FAIL });
          dispatch(AppActions.createDialogMessage('info', 'report:NO_CONTENT_TITLE', 'report:NO_CONTENT_MESSAGE'));
        }
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch({
          type: PRINT_REPORT_FAIL,
          payload: { message: errorMessages, error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
}

export const clearHistoryFile = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_HISTORY_FILE });
  };
};
